module.exports = __webpack_public_path__ + "static/media/china-bg.61e05d2c.mp3";